import React from 'react';
import { Message } from 'semantic-ui-react';
import _ from 'lodash';
import { createToast, toastType } from 'Common/ToastHelper';

export const ApiResultMessage = props => {
  const { result } = props;
  if (!result) return null;

  if (!_.isEmpty(result.Data) && result.Data.length !== 0) {
    return <Message positive>{result.Data}</Message>;
  } else if (!_.isEmpty(result.Errors) && result.Errors.length > 0) {
    const errorTitle = result.Errors[0].Title;
    const allSame = _.every(result.Errors, { Title: errorTitle });
    if (allSame) {
      return (
        <Message
          negative
          header={errorTitle}
          list={result.Errors.map(x => x.Message)}
        />
      );
    } else {
      return result.Errors.map((x, index) => {
        return (
          <Message negative key={index}>
            <Message.Header>{x.Title}</Message.Header>
            <p>{x.Message}</p>
          </Message>
        );
      });
    }
  } else {
    return null;
  }
};

export const NotificationMessage = (
  props,
  autoDismiss = true,
  hangTime = undefined,
  overrideSuccessMessage = null
) => {
  let result = props.data;
  if (!result) {
    result = props;
  }
  if (!result) return null;

  const renderList = errors => {
    return (
      <ul>
        {errors.map((x, index) => {
          return <li key={index}>{x.Message}</li>;
        })}
      </ul>
    );
  };

  if (!_.isEmpty(result.Errors) && result.Errors.length > 0) {
    const errorTitle = result.Errors[0].Title;
    const allSame = _.every(result.Errors, {
      Message: result.Errors[0].Message,
    });

    if (allSame && result.Errors.length > 1) {
      createToast(
        toastType.error,
        errorTitle,
        renderList(result.Errors),
        autoDismiss,
        hangTime
      );
    } else {
      result.Errors.forEach((x, index) => {
        createToast(toastType.error, x.Title, x.Message, autoDismiss, hangTime);
      });
    }
  }

  if (_.isEmpty(result.Errors) && result.Errors.length === 0) {
    if (!_.isEmpty(result.Data) && result.Data.length !== 0) {
      createToast(
        toastType.success,
        'Success',
        overrideSuccessMessage ? overrideSuccessMessage : result.Data,
        autoDismiss,
        hangTime
      );
    }
  }

  return null;
};

export const getMessageFromResponse = props => {
  let result = props.data;

  if (!result) {
    result = props;
  }
  if (!result) return null;

  const renderList = errors => {
    return (
      <ul>
        {errors.map((x, index) => {
          return <li key={index}>{x.Message}</li>;
        })}
      </ul>
    );
  };

  if (!_.isEmpty(result.Errors) && result.Errors.length > 0) {
    const errorTitle = result.Errors[0].Title;
    const allSame = _.every(result.Errors, { Title: errorTitle });
    if (allSame && result.Errors.length > 1) {
      return [
        {
          Title: errorTitle,
          Message: renderList(result.Errors),
        },
      ];
    } else {
      let myArray = [];
      result.Errors.forEach(x => {
        myArray.push({
          Title: x.Title,
          Message: x.Message,
        });
      });
      return myArray;
    }
  }

  if (_.isEmpty(result.Errors) && result.Errors.length === 0) {
    if (!_.isEmpty(result.Data) && result.Data.length !== 0) {
      return [
        {
          Title: 'Success',
          Message: result.Data,
        },
      ];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/messages/ApiResultMessage.js